<template>
  <div id="app">
    <!-- <nav>
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </nav>
    <router-view/> -->
    <index-view></index-view>
    <LoginDialog
      v-model="loginDialogVisible"
      :initial-mode="loginDialogMode"
      @send-code="handleSendCode"
      @submit="handleSubmit"
    />
  </div>
</template>
<script>
import IndexView from '@/views/index.vue'
import LoginDialog from '@/components/LoginDialog.vue'
export default {
  components: {
    IndexView,
    LoginDialog
  },
  computed: {
    loginDialogVisible: {
      get() {
        return this.$store.state.auth.loginDialogVisible
      },
      set(isVisible) {
        this.$store.dispatch(isVisible ? 'auth/openLoginDialog' : 'auth/closeLoginDialog')
      }
    },
    loginDialogMode() {
      return this.$store.state.auth.loginDialogMode
    }
  },
  methods: {
    handleSendCode(payload) {
      // 发送验证码
    },
    handleSubmit(payload) {
      // 提交表单
    }
  }
}
</script>
<style lang="scss">
#app {
  width: 100%;
}
</style>
